import { render, staticRenderFns } from "./modalDetectaRosto.vue?vue&type=template&id=9c5f1a1c"
import script from "./modalDetectaRosto.vue?vue&type=script&lang=js"
export * from "./modalDetectaRosto.vue?vue&type=script&lang=js"
import style0 from "./modalDetectaRosto.vue?vue&type=style&index=0&id=9c5f1a1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports